import * as React from 'react';
import type { LinkComponent } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';

interface NavLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: React.ReactNode;
}

const NavLinkComponent = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ children, ...props }, ref) => {
    return (
      <a ref={ref} {...props}>
        {children}
      </a>
    );
  }
);

const CreatedNavLink = createLink(NavLinkComponent);

export const CustomNavLink: LinkComponent<typeof NavLinkComponent> = ({
  children,
  ...props
}) => {
  return (
    <CreatedNavLink data-component="CustomNavLink" preload="intent" {...props}>
      {children}
    </CreatedNavLink>
  );
};
